import apiService from "../common/utils/apiService";
import * as collectionActions from "../slices/collectionSlice";
import { updateFilteredCollection, updateDateRange } from "../slices/filtersSlice";

const COLLECTIONS_URL = `/collections`;

const HIDDEN_COLLECTION_PREFIXES = ["airstrip-2021_", "detected-objects"];

const isHiddenCollection = (item) =>
    HIDDEN_COLLECTION_PREFIXES.some(
        (prefix) => item?.name?.startsWith(prefix)
    );

export const createCollection = (collectionDetails, callback) => async (dispatch) => {
    dispatch(collectionActions.createCollectionsRequest());
    try {
        let url = COLLECTIONS_URL;
        const response = await apiService.post(url, collectionDetails, {});
        if (response) {
            dispatch(collectionActions.createCollectionsSuccess(response));
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
    } catch (error) {
        dispatch(collectionActions.createCollectionsFailure());
        console.error('Error creating collection:', error);
    }
}

export const getCollections = (callback) => async (dispatch, getState) => {
    const state = getState();
    dispatch(collectionActions.getCollectionsRequest());
    try {
        let url = COLLECTIONS_URL;
        const allCollections = await apiService.get(url, null, {});
        const response = Array.isArray(allCollections)
            ? allCollections.filter((item) => !isHiddenCollection(item))
            : allCollections;
        dispatch(collectionActions.getCollectionsSuccess(response));
        if (Object.keys(state.filters.filteredCollection).length === 0 &&
            (response && response.length > 0)) {
            const collection = response.find((item) => item.name === "landsat-india") ?? response.at(-1);
            dispatch(updateFilteredCollection(collection));
            if (collection.firstItemDatetime && collection.lastItemDatetime) {
                dispatch(updateDateRange({
                    startDate: collection.firstItemDatetime,
                    endDate: collection.lastItemDatetime,
                }));
            }
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
    } catch (error) {
        dispatch(collectionActions.getCollectionsFailure());
        console.error('Error getting collection', error);
    }
}